require('../../modules/es6.object.define-property');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/define-property.js
// module id = 276
// module chunks = 8 9 10 12 13 32 34 35 37 38 40 53 54 55 66 72 74 75 77 78 89 92 93 94 97 106 109 111 113 116 118 119 120 121 125 129 133 134 135 142 144 145 146 147 148 149 150 151 154 155 156 159 162 164 165 166 168 169